function initHtmlTooltip() {
    const tooltip = document.createElement('div');
    tooltip.classList.add('tooltip');
    tooltip.textContent = '';
    document.body.appendChild(tooltip);

    const offsetX = 10;
    const offsetY = 10;

    document.querySelectorAll('[title]').forEach(el => {
        const title = el.getAttribute('title');
        if (null === title || '' === title.trim()) {
            return;
        }
        function adjustTooltip(event) {
            tooltip.textContent = title;

            const tooltipWidth = tooltip.getBoundingClientRect().width
            const tooltipHeight = tooltip.getBoundingClientRect().height


            let targetX = event.pageX + offsetX;
            let targetY = event.pageY + offsetY;

            if (window.innerWidth - targetX < tooltipWidth) {
                targetX -= tooltipWidth + offsetX;
            }

            if (window.innerHeight - targetY < tooltipHeight) {
                targetY -= tooltipHeight + offsetY;
            }

            tooltip.style.left = targetX + 'px';
            tooltip.style.top = targetY + 'px';
        }

        el.addEventListener('mousemove', (event) => {
            adjustTooltip(event);
        });

        el.addEventListener('mouseenter', (event) => {
            el.setAttribute('data-title', title);
            el.removeAttribute('title');
            adjustTooltip(event);
        });

        el.addEventListener('mouseleave', () => {
            el.setAttribute('title', title);
            window.setTimeout(() => {
                tooltip.textContent = ''
                tooltip.removeAttribute('style')
            }, 50)
        });
    });
}